/* eslint-disable camelcase */
import { durationLocalized } from '@/utils/travels'

export class TripAdditionalStatistics {
  constructor ({
    closed_eyes_duration = null, distraction_duration = null, yawning_duration = null,
    distraction_no_attention_duration = null, distraction_no_face_duration = null,
    belt_unfasten_duration = null,
    phone_usage_duration = null, smoking_duration = null, eating_duration = null,
    camera_sabotage_duration = null
  } = {}) {
    this._closedEyesDuration = closed_eyes_duration
    this._distractionDuration = distraction_duration
    this._distractionNoAttentionDuration = distraction_no_attention_duration
    this._distractionNoFaceDuration = distraction_no_face_duration
    this._yawningDuration = yawning_duration
    this._beltUnfastenDuration = belt_unfasten_duration
    this._phoneUsageDuration = phone_usage_duration
    this._smokingDuration = smoking_duration
    this._eatingDuration = eating_duration
    this._cameraSabotageDuration = camera_sabotage_duration
  }

  get closedEyesDuration () {
    return durationLocalized(this._closedEyesDuration)
  }

  get closedEyesDurationDetailed () {
    return durationLocalized(this._closedEyesDuration, true)
  }

  get distractionDuration () {
    return durationLocalized(this._distractionDuration)
  }

  get distractionNoAttentionDuration () {
    return durationLocalized(this._distractionNoAttentionDuration)
  }

  get distractionNoFaceDuration () {
    return durationLocalized(this._distractionNoFaceDuration)
  }

  get distractionDurationDetailed () {
    return durationLocalized(this._distractionDuration, true)
  }

  get yawningDuration () {
    return durationLocalized(this._yawningDuration)
  }

  get yawningDurationDetailed () {
    return durationLocalized(this._yawningDuration, true)
  }

  get beltUnfastenDuration () {
    return durationLocalized(this._beltUnfastenDuration)
  }

  get beltUnfastenDurationDetailed () {
    return durationLocalized(this._beltUnfastenDuration, true)
  }

  get phoneUsageDuration () {
    return durationLocalized(this._phoneUsageDuration)
  }

  get phoneUsageDurationDetailed () {
    return durationLocalized(this._phoneUsageDuration, true)
  }

  get smokingDuration () {
    return durationLocalized(this._smokingDuration)
  }

  get smokingDurationDetailed () {
    return durationLocalized(this._smokingDuration, true)
  }

  get eatingDuration () {
    return durationLocalized(this._eatingDuration)
  }

  get eatingDurationDetailed () {
    return durationLocalized(this._eatingDuration, true)
  }

  get cameraSabotageDuration () {
    return durationLocalized(this._cameraSabotageDuration)
  }

  get cameraSabotageDurationDetailed () {
    return durationLocalized(this._cameraSabotageDuration, true)
  }
}
